import React, { useEffect, useState } from "react";
import { AppLayout } from "../../../templates";
import { Box, Grid, Tab, Tabs } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { userActions, factoryActions, alertActions } from "../../../_redux/actions";
import { authorizationService } from "../../../_services";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models as BiModels, Report as BiReport, Embed as BiEmbed, service as BiService } from 'powerbi-client';
import { reportActions } from "../../../_redux/actions";
import styles from './BiReportsPage.module.scss'

const BiReportsPage = () => {
    const [value, setValue] = React.useState(0);
    const [sbuList, setSbuList] = React.useState([]);
    const [plantList, setPlantList] = React.useState([]);
    const [factoryList, setFactoryList] = React.useState([]);
    const [reportConfig, setReportConfig] = useState<BiModels.IReportEmbedConfiguration>({
        type: 'report',
        embedUrl: undefined,
        tokenType: BiModels.TokenType.Embed,
        accessToken: undefined,
        settings: undefined,
        filters: undefined
    });

    useEffect(() => {

        // Dispatch getUserDetail action to fetch factory list
        dispatch(userActions.getUserDetail(authorizationService.getAuthorizedUser().userEmail,
            (res) => {
                res.userFactories.map(item => (
                    setSbuList((old) => [...old, item.sbuName]),
                    item.plants.map(res => (
                        setPlantList((old) => [...old, res.name]),
                        res.factories.map(res1 =>
                            setFactoryList((old) => [...old, res1.name])
                        )
                    ))
                ))
            },
            (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }))

        // Dispatch getUserList action to fetch user list
        dispatch(userActions.getUserList(null,
            () => {
                // Success event
            },
            (error) => {
                // trigger alert onError
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }));

        // Dispatch getAllPlantList action to fetch plant data
        dispatch(factoryActions.getAllPlantList(
            authorizationService.getAuthorizedUser().isAdmin,
            () => {
                // Success event
            },
            (error) => { dispatch(alertActions.triggerAlert(true, error, 'error')) }
        ));
    }, [])

    useEffect(() => {
        let basicFilter;
        let reportType;
        switch (value) {
            case 0:
                reportType = 'IEDistributionReport'
                if (factoryList.length < 1) {
                    dispatch(userActions.getUserDetail(authorizationService.getAuthorizedUser().userEmail,
                        (res) => {
                            let facArr = []
                            res.userFactories.map(item =>
                                item.plants.map(res =>
                                    res.factories.map(res1 =>
                                        facArr.push(res1.name)
                                    )))

                            const basicFilter1: BiModels.IBasicFilter = {
                                $schema: "http://powerbi.com/product/schema#basic",
                                target: {
                                    table: "Rest Potential Merge",
                                    column: "Potential Improvement Summary.FactoryName"
                                },
                                operator: "In",
                                values: facArr,
                                filterType: 1
                            }
                            basicFilter = facArr.length > 0 ? basicFilter1 : null;
                        },
                        (error) => {
                            dispatch(alertActions.triggerAlert(true, error, 'error'))
                        }))
                }
                else {
                    const basicFilter1: BiModels.IBasicFilter = {
                        $schema: "http://powerbi.com/product/schema#basic",
                        target: {
                            table: "Rest Potential Merge",
                            column: "Potential Improvement Summary.FactoryName"
                        },
                        operator: "In",
                        values: factoryList,
                        filterType: 1
                    }
                    basicFilter = factoryList.length > 0 ? basicFilter1 : null;
                }
                break;
            case 1:
                reportType = 'PlantWiseScoreCardReport'
                const basicFilter2: BiModels.IBasicFilter = {
                    $schema: "http://powerbi.com/product/schema#basic",
                    target: {
                        table: "ScoreCard",
                        column: "Plant Name"
                    },
                    operator: "In",
                    values: plantList,
                    filterType: 1
                }
                basicFilter = sbuList.length > 0 ? basicFilter2 : null;
                break;
            case 2:
                reportType = 'PotentialReport'
                const basicFilter3: BiModels.IBasicFilter = {
                    $schema: "http://powerbi.com/product/schema#basic",
                    target: {
                        table: "PotentialReportData",
                        column: "FactoryName"
                    },
                    operator: "In",
                    values: factoryList,
                    filterType: 1
                }
                basicFilter = factoryList.length > 0 ? basicFilter3 : null;
                break;
            case 3:
                reportType = 'PotentialImprovementReport'
                const basicFilter4: BiModels.IBasicFilter = {
                    $schema: "http://powerbi.com/product/schema#basic",
                    target: {
                        table: "PotentialImprovementReport",
                        column: "FactoryName"
                    },
                    operator: "In",
                    values: factoryList,
                    filterType: 1
                }
                basicFilter = factoryList.length > 0 ? basicFilter4 : null;
                break;
            case 4:
                reportType = 'SummaryReport'
                const basicFilter5: BiModels.IBasicFilter = {
                    $schema: "http://powerbi.com/product/schema#basic",
                    target: {
                        table: "SummaryReportData",
                        column: "SBUName"
                    },
                    operator: "In",
                    values: sbuList,
                    filterType: 1
                }
                basicFilter = sbuList.length > 0 ? basicFilter5 : null;
                break;
            case 5:
                reportType = 'MASDBReport'
                break;
            case 6:
                reportType = 'DivisionDBReport'
                const basicFilter6: BiModels.IBasicFilter = {
                    $schema: "http://powerbi.com/product/schema#basic",
                    target: {
                        table: "Division Rank",
                        column: "SBUName"
                    },
                    operator: "In",
                    values: sbuList,
                    filterType: 1
                }
                basicFilter = sbuList.length > 0 ? basicFilter6 : null;
                break;
            case 7:
                reportType = 'PlantDBReport'
                const basicFilter7: BiModels.IBasicFilter = {
                    $schema: "http://powerbi.com/product/schema#basic",
                    target: {
                        table: "Plant Rank",
                        column: "PlantName"
                    },
                    operator: "In",
                    values: plantList,
                    filterType: 1
                }
                basicFilter = sbuList.length > 0 ? basicFilter7 : null;
                break;
            default:
                reportType = 'IEDistributionReport'
                const basicFilter8: BiModels.IBasicFilter = {
                    $schema: "http://powerbi.com/product/schema#basic",
                    target: {
                        table: "Rest Potential Merge",
                        column: "Potential Improvement Summary.FactoryName"
                    },
                    operator: "In",
                    values: factoryList,
                    filterType: 1
                }
                basicFilter = factoryList.length > 0 ? basicFilter8 : null;
        }
        // var reportType = value == 0 ? 'IEDistributionReport' 
        // : value == 1 ? 'PotentialReport' 
        // : value == 2 ? 'PotentialImprovementReport' 
        // : 'SummaryReport';

        dispatch(reportActions.getPowerBiReport(reportType
            , (res) => {
                setReportConfig({
                    ...reportConfig,
                    embedUrl: res.embedReports[0].embedUrl,
                    accessToken: res.embedToken.token,
                    filters: [basicFilter]
                });
            }
            , () => {

            }));
    }, [value]);

    interface TabPanelProps {
        children?: React.ReactNode;
        index: number;
        value: number;
    }

    const TabPanel = (props: TabPanelProps) => {
        const { children, value, index, ...other } = props;
        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`bi-report-tabpanel-${index}`}
                aria-labelledby={`bi-report-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box>
                        <PowerBIEmbed
                            embedConfig={reportConfig}
                            eventHandlers={eventHandlersMap}
                            cssClassName={styles.reportContainer}
                            getEmbeddedComponent={(embedObject: BiEmbed) => {
                                console.log(`Embedded object of type "${embedObject.embedtype}" received`);
                                console.log(embedObject);
                                //setReport(embedObject as BiReport);
                            }}
                        />
                    </Box>
                )}
            </div>
        );
    }

    const handleChange = (event: any, newValue: number) => {
        setValue(newValue);
    };

    const dispatch = useDispatch();

    const a11yProps = (index: number) => {
        return {
            id: `bi-report-tab-${index}`,
            'aria-controls': `bi-report-tabpanel-${index}`,
        };
    };

    // Map of event handlers to be applied to the embedding report
    const eventHandlersMap = new Map([
        ['loaded', function () {
            console.log('Report has loaded');
        }],
        ['rendered', function () {
            console.log('Report has rendered');

            // Update display message
            //setMessage('The report is rendered')
        }],
        ['error', function (event?: BiService.ICustomEvent<any>) {
            if (event) {
                console.error(event.detail);
            }
        }]
    ]);

    return (
        <AppLayout>
            <Grid container className={'appPageHeader'}>
                <Grid container item xs={12} sm={12} md={7} lg={7} justify="flex-start" alignContent="center">
                    <span className={'pageTitle'}>Summary <b>Reports</b></span>
                </Grid>
                <Grid container item xs={12} sm={12} md={5} lg={5} justify="flex-end" alignContent="center">

                </Grid>
            </Grid>
            <div className="appPageContent">
                <Box>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className="appTabGroup" indicatorColor="primary">
                        <Tab label="Dashboard" {...a11yProps(0)} />
                        <Tab label="Plant Wise ScoreCard" {...a11yProps(1)} />
                        <Tab label="Potential Report" {...a11yProps(2)} />
                        <Tab label="Potential Impr. Report" {...a11yProps(3)} />
                        <Tab label="Summary Report" {...a11yProps(4)} />
                        <Tab label="MAS Study Report" {...a11yProps(5)} />
                        <Tab label="Division Study Report" {...a11yProps(6)} />
                        <Tab label="Plant Study Report" {...a11yProps(7)} />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>Dashboard</TabPanel>
                <TabPanel value={value} index={1}>Plant Wise ScoreCard</TabPanel>
                <TabPanel value={value} index={2}>Potential Report</TabPanel>
                <TabPanel value={value} index={3}>Potential Impr. Report</TabPanel>
                <TabPanel value={value} index={4}>Summary Report</TabPanel>
                <TabPanel value={value} index={5}>MAS Study Report</TabPanel>
                <TabPanel value={value} index={6}>Division Study Report</TabPanel>
                <TabPanel value={value} index={7}>Plant Study Report</TabPanel>
            </div>
        </AppLayout>
    );
}

export default BiReportsPage;
